import React, { useEffect, useState } from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUserContext } from '../../AddEmployee/user-context/UserContext';
import '../../../../../../_metronic/assets/keenicons/duotone/style.css';

function EditEmployeeMenu() {
    const location = useLocation();
    const navigate = useNavigate();
    const [storedUserId, setStoredUserId] = useState<string | null>("");
    // Retrieve the user ID from localStorage
    const userId = localStorage.getItem('current_user_id');
    useEffect(() => {
        setStoredUserId(userId); // Store it in state
    }, [userId]);
    // Handle navigating back to the main menu
    const handleBackToMenu = () => {
        localStorage.removeItem('pathMatchedEditEmployeeMenu');
        navigate('/hr/employee/landing-page-employees');
         // Remove current_user_id from local storage and context
         localStorage.removeItem('Employee_Name');
         localStorage.removeItem('current_user_id');
    };
    // Handle rendering user ID (if needed for other logic)
    const handleRenderUserID = () => {
        setStoredUserId(null)
    };

    return (
        <div>
            {/* Sidebar */}
            <div>
                <Nav className="flex-column py-3">
                    <Nav.Item className="px-3 pb-2">
                        {/* Button to go back to menu */}
                        <Button onClick={handleBackToMenu} variant="light" className="w-100 mb-3">
                            Back to Menu
                        </Button>
                    </Nav.Item>
                    <Nav className="flex-column ms-3">
                        <Nav.Item className="px-3 nav-item-custom pb-2">
                            <Nav.Link
                                as={Link}
                                onClick={handleRenderUserID}
                                to="/hr/employee/list-employees"
                                className={`d-flex align-items-center text-white ${location.pathname.startsWith('/hr/employee/list-employees') ? 'active fw-bold' : ''
                                    }`}
                            >
                                <span className='menu-icon'>
                                    <i className="fa menu-icon-add-employee fa-list fs-5" />
                                </span>
                                <span className='menu-title-add-employee'>List of Employees</span>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    {/* Submenu */}
                    {storedUserId && (
                        <Nav className="flex-column ms-3">
                            {[
                                { path: 'edit-personal-details', label: 'Personal Details', icon: 'fa fa-user-plus' },
                                { path: 'edit-contact-details', label: 'Contact Details', icon: 'fa fa-envelope' },
                                { path: 'edit-dependent', label: 'Dependents', icon: 'fa fa-users' },
                                { path: 'edit-immigration', label: 'Immigration', icon: 'fa fa-globe' },
                                { path: 'edit-job', label: 'Job', icon: 'fa fa-briefcase' },
                                { path: 'edit-salary-details', label: 'Salary', icon: 'fa fa-dollar-sign' },
                                { path: 'edit-report-to', label: 'Report-to', icon: 'fa fa-user-check' },
                                { path: 'edit-qualification-details', label: 'Qualifications', icon: 'fa fa-graduation-cap' },
                                { path: 'edit-bank-details', label: 'Bank Details', icon: 'fa fa-university' }
                            ]

                                .map((item, index) => (
                                    <Nav.Item className="px-3 nav-item-custom pb-2">
                                        <Nav.Link
                                            as={Link}
                                            className={`d-flex align-items-center ${location.pathname === `/hr/employee/edit-employee/${item.path}`
                                                ? 'active fw-bold'
                                                : ''
                                                } text-white`}
                                            to={`/hr/employee/edit-employee/${item.path}`}
                                        >
                                            <span className='menu-icon'>
                                                <i className={`${item.icon} menu-icon-add-employee fs-5`} />
                                            </span>
                                            <span className='menu-title-add-employee'>{item.label}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                        </Nav>
                    )}
                </Nav>
            </div>
        </div>
    );
}

export default EditEmployeeMenu;
